import React from 'react';
import uuidv4 from 'uuid';
import PropTypes from 'prop-types';

//components:
import IntNumberFormatInput from '../../../components/int_number_input_formatter';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';


const styles = theme => ({
    root: {
        height: '100%',
        width: 240
    },
    containerPair: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        minWidth: 520,
        marginBottom: 10,
    },
    formControl: {
        display: 'flex',
        justifyContent: 'center',
        margin: '10px 25px 0',
        minWidth: 120,
        height: 72,
        width: 185,
    },
    buttonsContainer: {
        width: 520,
        padding: '25px 0 0 25px'
    },
    buttonsBottom: {
        marginRight: 15,
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    rtl: {
        textAlign: 'right',
    },
    checkbox: {
        marginBottom: 0,
        marginTop: 10,
    },
});

class EditVModeloMaquina extends React.Component {

    constructor(props) {
        super(props);

        this.state = {

            id: this.props.modelomaquina.id ? this.props.modelomaquina.id : uuidv4(),
            descr: this.props.modelomaquina.descr ? this.props.modelomaquina.descr : '',
            iTipoMaquina: this.props.modelomaquina.iTipoMaquina ? this.props.modelomaquina.iTipoMaquina : this.props.tiposMaquina[0].id,
            tieneContador: this.props.modelomaquina.tieneContador ? true : false,
            tipoRegalo: this.props.modelomaquina.tipoRegalo ? this.props.modelomaquina.tipoRegalo : 0,
            cvTipoMaquinaDescr: this.props.modelomaquina.cvTipoMaquinaDescr ? this.props.modelomaquina.cvTipoMaquinaDescr : this.props.tiposMaquina[0].descr,
        };

    };

    //handle texfield:
    handleValueChange = (event, field) => {
        this.setState({ ...this.state, [field]: event.target.value });

    };


    //handle checkbox:
    handleBooleanChange = event => {
        this.setState({ tieneContador: event.target.checked });
    };


    //handle select:
    handleChangeSelect = event => {

        const value = parseInt(event.target.value);

        this.setState({
            ...this.state,
            iTipoMaquina: value,
            cvTipoMaquinaDescr: this.props.tiposMaquina.find(tz => tz.id === value).descr
        });
    };


    fillSelectOptionList = () => {

        return this.props.tiposMaquina.map(tz => {

            return (
                <option key={tz.id} value={tz.id}>{tz.descr}</option>
            );

        })

    };


    render() {
        const { classes } = this.props;

        return (
            <div className={classes.root}>

                <div className={classes.containerPair}>
                    <FormControl className={classes.formControl}>
                        <TextField
                            id={'descr'}
                            label={'Descripción'}
                            placeholder={'Descripción'}
                            className={classes.textField}
                            margin="normal"
                            autoFocus
                            value={this.state.descr}
                            onChange={(event) => this.handleValueChange(event, 'descr')}
                        />
                    </FormControl>

                    <FormControl className={classes.formControl}>
                        <InputLabel htmlFor="tipos-zona-placeholder">
                            Tipo Maquina
                    </InputLabel>
                        <Select
                            native
                            value={this.state.iTipoMaquina}
                            onChange={(event) => this.handleChangeSelect(event)}
                            name={'cvTipoMaquinaDescr'}
                        >
                            {this.fillSelectOptionList()}
                        </Select>
                    </FormControl>
                </div>

                <div className={classes.containerPair}>
                    <FormControl className={classes.formControl}>
                        <FormControlLabel
                        className={classes.checkbox}
                            control={
                                <Checkbox
                                    checked={this.state.tieneContador}
                                    onChange={this.handleBooleanChange}
                                    value='tieneContador'
                                />
                            }
                            label="Tiene Contador"
                        />
                    </FormControl>


                    <FormControl className={classes.formControl}>
                        <TextField
                            id={'tipoRegalo'}
                            label={'Tipo Regalo'}
                            placeholder={'Tipo Regalo'}
                            className={classes.textField}
                            margin="normal"
                            InputProps={{ classes: { input: classes.rtl }, inputComponent: IntNumberFormatInput }}
                            value={this.state.tipoRegalo}
                            onChange={(event) => this.handleValueChange(event, 'tipoRegalo')}
                        />
                    </FormControl>
                </div>


                <div className={classes.buttonsContainer}>
                    <Button className={classes.buttonsBottom} variant="contained" color="secondary" onClick={() => this.props.hideDialog()}>Cerrar</Button>
                    <Button className={classes.buttonsBottom} variant="contained" color="primary" onClick={() => {
                        const modeloMaquina = {
                            id: this.state.id,
                            descr: this.state.descr,
                            iTipoMaquina: this.state.iTipoMaquina,
                            tieneContador: this.state.tieneContador ? 1 : 0,
                            tipoRegalo: parseInt(this.state.tipoRegalo),
                            cvTipoMaquinaDescr: this.state.cvTipoMaquinaDescr
                        }

                        if (this.props.checkVModeloMaquina(modeloMaquina)) {

                            this.props.okHandler(modeloMaquina);
                            this.props.hideDialog();
                        }
                    }
                    }>Guardar</Button>
                </div>
            </div>
        )
    };

};

EditVModeloMaquina.propTypes = {
    modelomaquina: PropTypes.object.isRequired,
    tiposMaquina: PropTypes.array.isRequired,
    checkVModeloMaquina: PropTypes.func.isRequired,
    okHandler: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
};


export default withStyles(styles, { withTheme: true })(EditVModeloMaquina);